import React from "react";

import { cn } from "../utils/rechercheUtils";

export default function RechercheTabs({
  groups = [],
  total = 0,
  activeSection,
  onSection,
}) {
  return (
    <div className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-1 md:flex-wrap md:overflow-visible">
      <button
        type="button"
        onClick={() => onSection("all")}
        className={cn(
          "inline-flex shrink-0 items-center gap-2 rounded-full border px-4 py-2 text-sm font-bold transition",
          activeSection === "all"
            ? "border-[#1277B9] bg-[#1277B9] text-white shadow-sm"
            : "border-slate-200 bg-white text-slate-700 hover:border-[#1277B9]/50 hover:bg-sky-50 hover:text-[#1277B9] dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:hover:bg-slate-900"
        )}
      >
        Tous
        <span
          className={cn(
            "rounded-full px-2 py-0.5 text-xs",
            activeSection === "all"
              ? "bg-white/20 text-white"
              : "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-300"
          )}
        >
          {total}
        </span>
      </button>

      {groups.map((group) => {
        const active = activeSection === group.key;
        const Icon = group.icon;

        return (
          <button
            key={group.key}
            type="button"
            onClick={() => onSection(group.key)}
            className={cn(
              "inline-flex shrink-0 items-center gap-2 rounded-full border px-4 py-2 text-sm font-bold transition",
              active
                ? "border-[#1277B9] bg-[#1277B9] text-white shadow-sm"
                : "border-slate-200 bg-white text-slate-700 hover:border-[#1277B9]/50 hover:bg-sky-50 hover:text-[#1277B9] dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:hover:bg-slate-900"
            )}
          >
            {Icon && <Icon className="h-4 w-4" />}
            {group.label}
            <span
              className={cn(
                "rounded-full px-2 py-0.5 text-xs",
                active
                  ? "bg-white/20 text-white"
                  : "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-300"
              )}
            >
              {group.count}
            </span>
          </button>
        );
      })}
    </div>
  );
}